
import { base } from "./base";
import { emartmall } from "./emartmall";
export const ROUTE_NAME = {
	...base,
    emartmall: emartmall,

};
